import { staticImagesRelativePath } from './staticImagesRelativePath';

/** Mirrors the AiProvider enum from common/enums.proto: there is no endpoint listing them */
export const AI_PROVIDERS = [
  'DEEPSEEK',
  'OPEN_AI',
  'GEMINI',
  'FLUX2API',
  'BFL',
  'KLINGAI',
  'MODELARK',
];

const aiProviderNames: { [key: string]: string } = {
  OPEN_AI: 'OpenAI',
  GEMINI: 'Gemini',
  DEEPSEEK: 'DeepSeek',
  KLINGAI: 'Kling AI',
  // BytePlus ModelArk, the platform the Seedance video models are served from
  MODELARK: 'ModelArk',
  // the two ways to reach FLUX: through the flux2api.com reseller, and from its vendor directly
  FLUX2API: 'FLUX (flux2api)',
  BFL: 'FLUX (Black Forest Labs)',
};

/**
 * Whether the backend still knows this provider name. A tariff saved before a provider was renamed
 * (FLUX before FLUX2API and BFL, SEEDANCE before MODELARK) keeps the old name, and apisupport refuses a
 * request that carries it — so what the panel sends is narrowed to the names it knows.
 */
export const isKnownAiProvider = (aiProvider: string) => AI_PROVIDERS.includes(aiProvider);

export const knownAiProviders = (aiProviders: string[] = []) =>
  aiProviders.filter(isKnownAiProvider);

/** The backend sends raw enum values, so an unknown provider keeps its own name */
export const formatAiProviderName = (aiProvider: string) => {
  return aiProviderNames[aiProvider] ?? aiProvider;
};

export const getAiProviderIcon = (aiProvider: string) => {
  const iconKey = aiProvider in staticImagesRelativePath.aiProviderIcons ? aiProvider : 'DEFAULT';
  return staticImagesRelativePath.aiProviderIcons[iconKey]();
};
